export const queryParams = {
	page          : 'pagina',
	query         : 'q',
	regions       : 'regions',
	subjects      : 'vakken',
	theme         : 'thema',
	topTheme      : 'topthema',
	vicinityCity  : 'idb',
	vicinityCoords: 'idb_geo',
};
